const  id =  {
 translation: {
  "account": "Akun",
  "auth_confirm_read": "Saya telah membaca dan memahami",
  "auth_terms_conditions": "Syarat & Ketentuan",
  "auto_input_password": "Masukkan kata kunci",
  "auto_input_username": "Masukkan nama pengguna",
  "auto_password": "Kata sandi",
  "auto_username": "nama belakang",
  "back_home": "Kembali ke halaman utama",
  "cancel_password": "Membatalkan",
  "change_password": "Ganti kata sandi",
  "confirm_new_password": "Konfirmasikan kata sandi baru",
  "coppy_link_error": "Salin Kegagalan Tautan",
  "coppy_link_success": "Salin tautan dengan sukses",
  "current_password": "kata sandi saat ini",
  "download_file_error": "Unduh kegagalan",
  "edit_profile_label_cancle": "Membatalkan",
  "edit_profile_label_confirm": "Mengonfirmasi",
  "edit_profile_success": "Informasi yang berhasil",
  "edit_profile_text_warning_description": "Anda yakin ingin membatalkan perubahan?",
  "email": "Email",
  "error_500": "Sistem kelebihan, silakan coba nanti",
  "error_backhome": "Kembali ke halaman utama",
  "error_confirm_new_password": "Berbeda dengan kata sandi baru",
  "error_new_password": "Kata sandi baru tidak bisa seperti kata sandi saat ini",
  "error_page_note_found": "Halaman tidak ditemukan",
  "error_password": "Kata sandi saat ini tidak benar",
  "fan_test_key": "in test",
  "footer_title": "© Hak Cipta milik",
  "forgot_password": "Tidak ingat kata sandi",
  "forgot_password_change_password_success": "Ubah kata sandi dengan sukses",
  "forgot_password_email_verified_account": "Email belum mendaftarkan akun",
  "forgot_password_input_placeholder": "Masukkan Kata Sandi Baru Anda",
  "forgot_password_reset_password": "Setel ulang kata sandi",
  "forgot_password_success_title": "Yayy! Ubah kata sandi dengan sukses",
  "forgot_password_title": "Anda memasukkan email pendaftaran yang benar untuk mendapatkan kata sandi kembali 😥",
  "handle_redirect": "Redirect",
  "input_confirm_new_password": "Masukan kata sandi yang baru",
  "input_current_password": "Masukkan kata sandi saat ini",
  "input_new_password": "Masukkan Kata Sandi Baru Anda",
  "login": "Gabung",
  "login_error_email_exist": "Email belum mendaftarkan akun",
  "login_error_email_format": "Email tidak dalam format.",
  "login_error_email_required": "Masukkan email Anda",
  "login_error_limit_fail": "Anda telah memasukkan kata sandi yang salah lebih dari nomor yang ditentukan. Silakan coba lagi nanti",
  "login_error_password": "Kata sandi salah",
  "login_error_phone_exist": "Nomor telepon belum terdaftar",
  "login_error_phone_format": "Nomor telepon tidak dalam format yang tepat.",
  "login_forget_password": "Apakah Anda lupa kata sandinya?",
  "login_now": "Masuk sekarang",
  "login_page_close": "Menutup",
  "login_page_content": "Platform Passio untuk penggemar",
  "login_page_copy_right": "© Passio -",
  "login_page_password_placeholder": "ป้อนรหัสผ่านของคุณ",
  "login_page_placeholder": "Masukkan email Anda",
  "login_page_question": "Belum punya akun?",
  "login_page_register": "Daftar sekarang",
  "login_page_title": "Gabung",
  "login_password_placeholder": "Masukkan kata kunci",
  "login_phone_placeholder": "Masukkan Nomor Telepon Anda",
  "login_reinstall_password": "Pasang kembali kata sandi",
  "login_success": "Masuk dengan sukses",
  "login_success_title": "Yayy! Masuk dengan sukses",
  "new_password": "Kata sandi baru",
  "next": "Berikutnya",
  "otp_accuracy": "Kirim",
  "otp_continute_without_verification": "Lanjutkan tanpa otentikasi",
  "otp_email_title": "Kode otentikasi telah dikirim ke email",
  "otp_error_invalid_email": "Email tidak dalam format.",
  "otp_error_limit_send_otp": "Jumlah waktu masuk melebihi batas yang diizinkan, silakan kirim kembali OTP baru",
  "otp_error_limit_time": "Anda telah memanipulasi lebih dari berapa kali diizinkan. Harap kembalikan setelah {{time}} untuk melanjutkan.",
  "otp_error_otp_not_found": "Kode OTP tidak ada.",
  "otp_error_timeout": "OTP telah kedaluwarsa, silakan kirim kembali OTP.",
  "otp_resend": "Kirim OTP kembali",
  "otp_screen_please_wait_after": "detik untuk dikirim kembali.",
  "otp_screen_please_wait_before": "Harap tunggu",
  "password": "Kata sandi",
  "password_accept_condition": "Setelah menekan tombol pendaftaran, Anda menerima",
  "password_cancle": "Membatalkan",
  "password_change": "Ubah kata sandi",
  "password_confirm": "Mengonfirmasi",
  "password_error_digit": "Minimum 1 digit",
  "password_error_min_length": "Panjangnya lebih dari 8 karakter",
  "password_error_timeout": "Seiring waktu mengatur kata sandi, silakan beroperasi kembali.",
  "password_error_uppercase": "Minimum 1 huruf kapital",
  "password_input_placeholder": "E.g: Matkhau112361",
  "password_max": "Harap masukkan karakter maksimum {{max}}",
  "password_min": "Harap masukkan setidaknya {{min}} karakter",
  "password_required": "Harap masukkan informasi ini",
  "password_setup": "Pengaturan Kata Sandi",
  "password_term_condition": "Syarat & Ketentuan",
  "phone": "Nomor telepon",
  "register": "Daftar",
  "register_email_placeholder": "Masukkan alamat email Anda",
  "register_erro_min_length": "Panjang minimum {{min}} karakter",
  "register_error_email_error": "Email tidak dalam format.",
  "register_error_email_existed": "Email telah mendaftarkan akun",
  "register_error_email_invalid_format": "Email tidak dalam format.",
  "register_error_limit_send": "Anda telah memanipulasi lebih dari berapa kali diizinkan. Harap kembalikan setelah {{time}} untuk melanjutkan.",
  "register_error_max_length": "Hanya memaksimalkan {{max}} karakter",
  "register_error_username_existed": "nama pengguna tersedia",
  "register_error_username_matches": "Hanya karakter yang diizinkan dari a-z dan 0-9",
  "register_otp": "Otentikasi OTP",
  "register_page_description": "Buat akun Anda dan mulailah perjalanan di Passio",
  "register_page_title": "Daftar akun",
  "register_phone_placeholder": "Masukkan nomor telepon Anda",
  "register_success": "Mendaftar kesuksesan",
  "register_success_description": "Selamat atas pendaftaran akun Anda yang sukses. Selamat datang di platform Passio",
  "register_success_title": "Yayy! Mendaftar kesuksesan",
  "register_verified_email": "Email telah mendaftarkan akun",
  "save_password": "Menyimpan",
  "save_password_false": "Kata sandi belum diubah",
  "save_password_success": "Anda telah berhasil mengubah kata sandi anda",
  "shoutout_back": "Kembali",
  "shoutout_content": "Isi",
  "shoutout_create_request": "Membuat persyaratan",
  "shoutout_created_at": "Created at",
  "shoutout_decline": "Tolak",
  "shoutout_expired_time": "Expired time",
  "shoutout_feed_back": "Umpan balik dari {{name}}",
  "shoutout_new": "Baru",
  "shoutout_occasion_advice": "Nasihat",
  "shoutout_occasion_birthday": "Hari ulang tahun",
  "shoutout_occasion_mobilize": "Mengerahkan",
  "shoutout_occasion_other": "Acara lainnya",
  "shoutout_occasion_question": "Pertanyaan",
  "shoutout_occasion_special": "Acara khusus",
  "shoutout_pronoun_aunt": "Merindukan",
  "shoutout_pronoun_big_uncle": "Paman",
  "shoutout_pronoun_bro": "Anda",
  "shoutout_pronoun_friend": "Teman",
  "shoutout_pronoun_grandfather": "Kakek",
  "shoutout_pronoun_grandmother": "Nenek",
  "shoutout_pronoun_he": "Kakak",
  "shoutout_pronoun_she": "Kakak perempuan",
  "shoutout_pronoun_uncle": "Paman",
  "shoutout_reject_reason": "Alasan penolakan",
  "shoutout_replied": "Dibuat",
  "shoutout_request_code": "Request code",
  "shoutout_request_detail": "Detail diperlukan",
  "shoutout_request_noti": "Permintaan sedang dibuat",
  "shoutout_request_status": "Persyaratan",
  "shoutout_share": "Membagikan",
  "shoutout_to": "Tiba",
  "spl_add_item_to_live": "Add products to LIVE",
  "spl_add_link": "Find products",
  "spl_add_link_content_success": "MUST CLICK on the link to enter the correct livestream containing your product!",
  "spl_add_link_error_content": "Currently unable to add products to live",
  "spl_add_link_error_title": "Add product to cart Live Error",
  "spl_add_link_title": "Add link",
  "spl_add_link_title_success": "Add products to cart Live success",
  "spl_back": "Back",
  "spl_cannot_add_item_to_shopee_live_session": "Cannot add item to Shopee live",
  "spl_cannot_find_seller": "Can't find live person information",
  "spl_close": "Close",
  "spl_cps_token_is_empty": "Invalid information",
  "spl_go_to_live_label": "Go now",
  "spl_guide_text": "Instructions for using the tool",
  "spl_invalid_url": "Invalid url",
  "spl_item_index": "The product order number in the live basket is",
  "spl_item_link_click_here": "Click this link",
  "spl_link_accept": "Invalid link",
  "spl_link_is_not_empty": "Link cannot be empty",
  "spl_ok": "ok",
  "spl_paste_link_here": "Paste the link here",
  "spl_position_in_live_label": "Position in LIVE",
  "spl_product_already_exists_in_live": "Sản phẩm đã tồn tại trong live",
  "spl_product_empty_searching_label": "No products found",
  "spl_product_invalid": "Please enter the correct Shopee product link",
  "spl_related_product_list_header_label": "Shopee deal hunting",
  "spl_related_product_list_title": "Related products are available in live",
  "spl_shopee_session_id_is_empty": "Not ready to live",
  "spl_title": "Shopee live",
  "spl_view_related_product_list_label": "View related products",
  "ss_add_voucher_successs": "Terapkan kode yang berhasil",
  "ss_back_donation_detail": "Pembayaran",
  "ss_back_to_homepage_creator": "Kembali ke beranda Kreator",
  "ss_back_tod_detail": "Pembayaran",
  "ss_brand_gift_cashback": "Cashback",
  "ss_brand_gift_deal_name": "id_Tên deal",
  "ss_brand_gift_deal_price": "id_Giá deal",
  "ss_brand_gift_does_have_gift": "Iya",
  "ss_brand_gift_does_not_have_gift": "Tidak",
  "ss_brand_gift_has_gift": "Hadiah",
  "ss_brand_gift_heart": "jumlah hati",
  "ss_brand_gift_heart_cashback_heart": "id_Đã hoàn",
  "ss_brand_gift_heart_left_heart": "id_Còn lại",
  "ss_brand_gift_heart_link_text": "klik disini untuk lihat jumlah hati",
  "ss_brand_gift_heart_total_heart": "total hati",
  "ss_brand_gift_order_amount": "jumlah penjualan",
  "ss_brand_gift_order_support_info": "id_Bạn cần giúp đỡ",
  "ss_brand_gift_payment_history": "Brand Gift",
  "ss_brand_gift_showing_after_heart_text": "Capai",
  "ss_brand_gift_showing_before_heart_text": "Nomor",
  "ss_brand_gift_support_method": "id_Kênh hỗ trợ",
  "ss_brand_gift_title_type_ecommerce": "Online",
  "ss_brand_gift_title_type_o2o": "Offline",
  "ss_brand_gift_voucher": "voucher pakai",
  "ss_brand_rating_KOL_domain": "id_Trang KOL",
  "ss_brand_rating_back": "id_Hủy bỏ",
  "ss_brand_rating_back_to_payment_history": "id_Lịch sử mua hàng",
  "ss_brand_rating_button_update_payment_info": "id_Cập nhật ngay",
  "ss_brand_rating_cancel_order": "en_Admin hủy deal đơn hàng",
  "ss_brand_rating_cancel_order_sub_step_1": "id_Bạn đã cập nhật thông tin đơn hàng sai. Admin đã từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_cancel_order_sub_step_2": "id_Bạn đã cập nhật thông tin đánh giá sai 2 lần. Admin từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_cashback": "id_Hoàn",
  "ss_brand_rating_content_1": "id_1. Ảnh đơn hàng yêu cầu các thông tin:",
  "ss_brand_rating_content_2": "id_2. Mã đơn hàng là mã được sàn TMDT cung cấp cho người mua sau khi tiến hành đặt hàng thành công.",
  "ss_brand_rating_content_3": "id_3. Email là thông tin bạn đã cung cấp để đăng ký nhận deal thành công.",
  "ss_brand_rating_content_child_1": "id_Đánh giá 5 sao (bắt buộc)",
  "ss_brand_rating_content_child_2": "id_Nội dung đánh giá tốt về sản phẩm (bắt buộc)",
  "ss_brand_rating_content_child_3": "id_Có ảnh/video về sản phẩm (không bắt buộc)",
  "ss_brand_rating_cover_image_helper": "id_Hỗ trợ: JPG, JPEG, GIF, PNG, BMP, WebP, tối đa 4MB",
  "ss_brand_rating_details_order": "id_Chi tiết đơn hàng",
  "ss_brand_rating_discount": "id_Giảm",
  "ss_brand_rating_edit": "id_Chỉnh sửa",
  "ss_brand_rating_end_time": "id_Hạn Deal",
  "ss_brand_rating_error_404": "id_Bạn không được phép truy cập vào link này",
  "ss_brand_rating_fill_code": "id_Mã đơn hàng",
  "ss_brand_rating_fill_email": "Email",
  "ss_brand_rating_get_cashback_from_passio": "id_Nhận hoàn tiền từ Passio",
  "ss_brand_rating_get_cashback_from_passio_sub": "id_Thời gian hoàn tiền tối đa trong 7 ngày. Trong trường hợp chưa cung cấp thông tin thanh toán, bạn cần cập nhật để nhận hoàn tiền.",
  "ss_brand_rating_order_code": "en_Mã đơn hàng",
  "ss_brand_rating_order_content_child_1": "id_Tên sản phẩm trùng với tên sản phẩm của deal",
  "ss_brand_rating_order_content_child_2": "id_Mã đơn hàng",
  "ss_brand_rating_order_content_child_3": "id_Khoảng thông báo xác nhận chờ thanh toán (COD) và chờ vận chuyển (đã thanh toán)",
  "ss_brand_rating_order_heart": "id_Tim tích lũy",
  "ss_brand_rating_placeholder_code": "id_Nhập mã đơn hàng",
  "ss_brand_rating_register_deal_time": "id_Thời gian đăng ký Deal",
  "ss_brand_rating_save": "id_Lưu",
  "ss_brand_rating_showing_after_heart_text": "id_Danh sách sản phẩm",
  "ss_brand_rating_status": "id_Trạng thái",
  "ss_brand_rating_status_failed": "id_Từ chối",
  "ss_brand_rating_status_new": "id_Đang chờ",
  "ss_brand_rating_status_success": "id_Thành công",
  "ss_brand_rating_step_0_description": "id_Đơn hàng đăng ký từ hệ thống",
  "ss_brand_rating_step_0_title": "id_Đăng ký nhận Deal",
  "ss_brand_rating_step_1_description": "id_Upload ảnh đơn hàng hợp lệ và cập nhật các thông tin yêu cầu.",
  "ss_brand_rating_step_1_description_fail": "id_Bạn đã cập nhật thông tin đơn hàng sai. Admin đã từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_step_1_fail": "id_Admin đã từ chối thông tin ảnh của bạn",
  "ss_brand_rating_step_1_pending": "id_Đơn hàng đang chờ admin xét duyệt",
  "ss_brand_rating_step_1_title": "en_Cập nhật đơn hàng",
  "ss_brand_rating_step_2_description": "id_Upload ảnh đánh giá của bạn về sản phẩm mà bạn đã nhận",
  "ss_brand_rating_step_2_fail": "id_Admin đã từ chối thông tin ảnh của bạn",
  "ss_brand_rating_step_2_pending_1": "en_Đơn hàng đang chờ admin xét duyệt",
  "ss_brand_rating_step_2_pending_2": "id_Bạn đã cập nhật sai thông tin. Chỉ còn 1 lần để bạn cập nhật lại.",
  "ss_brand_rating_step_2_title": "id_Đánh giá đơn hàng 5*",
  "ss_brand_rating_step_3_description": "id_Thời gian hoàn tiền tối đa trong 7 ngày. Trường hợp bạn chưa cung cấp thông tin thanh toán, vui lòng cập nhật để nhận hoàn tiền.",
  "ss_brand_rating_step_3_description_clamp_heath": "id_Số tiền được hoàn tương đương với",
  "ss_brand_rating_step_3_description_done": "id_Thời gian hoàn tiền tối đa trong 7 ngày.",
  "ss_brand_rating_step_3_description_heart": "id_{{heart}}❤.",
  "ss_brand_rating_step_3_title": "id_Nhận hoàn tiền từ Passio",
  "ss_brand_rating_text_cash_back": "id_Hoàn tiền",
  "ss_brand_rating_text_percent": "id_Hoàn",
  "ss_brand_rating_title": "id_Tải ảnh đơn hàng",
  "ss_brand_rating_title_detail_order": "id_Chi tiết đơn hàng",
  "ss_brand_rating_title_hepler": "id_Lưu ý:",
  "ss_brand_rating_title_upload_rating": "id_Tải ảnh đánh giá đơn hàng",
  "ss_brand_rating_toast_success": "id_Bạn đã gửi thông tin thành công",
  "ss_brand_rating_update_order": "id_Cập nhật đơn đặt hàng",
  "ss_brand_rating_update_order_sub": "id_Bạn cần cập nhật thông tin mua đơn hàng thành công.",
  "ss_brand_rating_update_payment": "id_Câp nhật thông tin thanh toán",
  "ss_brand_rating_update_payment_info": "id_Cập nhật thanh toán",
  "ss_brand_rating_update_rating_sub": "id_Bạn cần cập nhật thông tin đánh giá 5 sao về sản phẩm",
  "ss_brand_rating_upload_cover_image": "id_Ảnh đơn hàng",
  "ss_brand_rating_upload_file_format_invalid_content": "Format gambar tidak valid. Format yang didukung: JPG, JPEG, GIF, PNG, BMP, WebP",
  "ss_brand_rating_upload_file_size_invalid_content": "Silakan pilih file dengan ukuran maksimum 10MB",
  "ss_brand_rating_upload_order": "id_Tải ảnh đơn hàng",
  "ss_brand_rating_upload_order_again": "en_Tải lại ảnh đơn hàng",
  "ss_brand_rating_upload_rating": "id_Cập nhật thông tin đánh giá 5 sao",
  "ss_brand_rating_upload_rating_again": "id_Cập nhật lại thông tin đánh giá 5 sao",
  "ss_brand_rating_upload_success_modal_order": "id_Chúc mừng bạn đã tải ảnh đơn hàng thành công! Bạn có thể theo dõi thêm lịch sử và trạng thái mua hàng.",
  "ss_brand_rating_upload_success_modal_rating": "id_Để nhận được hoàn tiền của chúng tôi, bạn cần cập nhật thông tin thanh toán",
  "ss_brand_rating_validate_code": "id_Trường dữ liệu không được để trống",
  "ss_brand_rating_validate_upload": "id_Trường dữ liệu không được để trống",
  "ss_call_hotline": "Hubungi hotline",
  "ss_checkout_disclamer_content_popup_tiktok": "untuk memperlancar proses pembayaran, silahkan pilih \"Buka di browser\"",
  "ss_checkout_disclamer_popup_tiktok": "Info Penting",
  "ss_checkout_email_after": "Bagian dari '@' tidak berisi ikon ''",
  "ss_checkout_email_before": "Bagian belakang '@' tidak berisi ikon ''",
  "ss_checkout_email_duplicate": "Bagian di belakang '@' tidak boleh berisi '@'",
  "ss_checkout_email_must": "Harap sertakan '@' dalam surat.",
  "ss_checkout_phone_require": "Harap masukkan nomor telepon",
  "ss_checkout_select_voucher": "Anda memiliki kode diskon?",
  "ss_checkout_voucher_empty_text": "Tidak ada kode diskon",
  "ss_checkout_voucher_empty_text_suggest": "Untuk menambahkan kode diskon, silakan masukkan & tekan tombol \"Aplikasi\" di bagian atas",
  "ss_convert_heart_amount_error": "Hati belum cukup",
  "ss_convert_heart_button": "Hasil hati",
  "ss_convert_heart_choose_phone_scratch_card": "Masukkan Rate Card",
  "ss_convert_heart_convert_btn_cancle": "Batalkan",
  "ss_convert_heart_convert_btn_confirm": "Konfirmasi",
  "ss_convert_heart_error_phone_format": "Masukkan No HP yang aktif",
  "ss_convert_heart_error_phone_required": "Masukkan No HP",
  "ss_convert_heart_info_1_hearts_convert": "1 hati",
  "ss_convert_heart_instruct_phone_number": "Masukkan No HP untuk menerima pulsa",
  "ss_convert_heart_number_convert": "Total hasil dari hati",
  "ss_convert_heart_phone_number_input": "No HP",
  "ss_convert_heart_placeholder_phone_number": "Masukkan No HP",
  "ss_convert_heart_request_existed": "Request pencairan hati masih dalam review. Silahkan coba lagi nanti",
  "ss_convert_heart_send_request_convert": "Kirim request",
  "ss_convert_heart_success": "Request berhasil. Tunggu 3-5 hari kerja",
  "ss_convert_heart_title_popup": "Buat request pencairan hati",
  "ss_convert_heart_verify_account_btn_cancel": "Batalkan",
  "ss_convert_heart_verify_account_btn_confirm": "Verifikasi Akun",
  "ss_convert_heart_warning_account_des_1": "Silahkan akses",
  "ss_convert_heart_warning_account_des_2": "Info Personal",
  "ss_convert_heart_warning_account_des_3": "Untuk verifikasi akun",
  "ss_convert_heart_warning_convert_des": "Apakah kamu ingin mencairkan hasil hati menjadi pulsa ke nomor HP ini?",
  "ss_convert_heart_warning_convert_title": "Konfirmasi?",
  "ss_copied": "Disalin",
  "ss_copy_failed": "Copy failed",
  "ss_create_account_donation": "Buat Akun",
  "ss_creator": "Pencipta",
  "ss_creator_tod": "Pencipta",
  "ss_decline_status_tod": "Menolak",
  "ss_details": "Details",
  "ss_disable_referral_button_share": "Event sudah berakhir",
  "ss_discount_ammount": "Diskon",
  "ss_donate_success": "Uang keberuntungan yang sukses",
  "ss_donation_btn_checkout": "Pembayaran",
  "ss_donation_checkout_email_notification": "👉 Produk kamu akan dikirim melalui email, harap masukkan info dengan benar.",
  "ss_donation_checkout_email_title": "Email",
  "ss_donation_checkout_phone_placeholder": "09xxxxxx",
  "ss_donation_checkout_phone_title": "Nomor handphone",
  "ss_donation_checkout_private_message_title": "Mengatur metode privat untuk pesan kamu",
  "ss_donation_checkout_user_message_title": "Pesan ke Kreator",
  "ss_donation_code": "Kode Dukungan",
  "ss_donation_confirm_leave_order": "Apakah kamu ingin keluar?",
  "ss_donation_message_from_user": "Pesan dari Anda",
  "ss_donation_name_kol": "Menyumbangkan",
  "ss_donation_pending_title": "Pertukaran sedang dalam proses",
  "ss_donation_time": "Waktu dukungan",
  "ss_donation_user_message_placeholder": "Coba kirim pesan ke Kreator🤑",
  "ss_duplicate_email": "Email telah mendaftarkan akun",
  "ss_duplicate_username": "nama pengguna tersedia",
  "ss_edit_profile": "Edit catatan",
  "ss_email": "Email",
  "ss_enter_course": "Bergabung sekarang",
  "ss_error_not_enough_money": "Kesalahan terjadi, saat ini tidak dapat dibayar",
  "ss_expired_voucher": "Maaf! Kode diskon ini telah kedaluwarsa",
  "ss_fail_name_kol": "kegagalan",
  "ss_fan_add_voucher_button": "Menerapkan",
  "ss_fan_brand_gift_title": "id_ƯU ĐÃI THƯƠNG HIỆU",
  "ss_fan_brand_rating_title": "id_GIAN HÀNG BÍ MẬT",
  "ss_fan_checkout_total_price": "Total",
  "ss_fan_date_picker_text_custom_range": "id_Tùy chỉnh khoảng thời gian",
  "ss_fan_date_picker_text_last_n_day": "id_{{n}} ngày gần nhất",
  "ss_fan_date_picker_text_last_week": "id_Tuần trước",
  "ss_fan_date_picker_text_this_month": "id_Tháng này",
  "ss_fan_date_picker_text_this_week": "id_Tuần này",
  "ss_fan_date_picker_text_today": "id_Hôm nay",
  "ss_fan_date_picker_text_yesterday": "id_Hôm qua",
  "ss_fan_empty_heart": "id_Không có đơn hàng được hoàn tim",
  "ss_fan_exclusive_passio_badge": "Eksklusif",
  "ss_fan_input_voucher_placeholder": "Masukan kode",
  "ss_fan_my_title": "Kode diskon saya",
  "ss_fan_no_photo_has_been_selected": "id_Chưa có ảnh nào được chọn",
  "ss_fan_profile_help_channel_fb": "Kênh hỗ trợ",
  "ss_fan_profile_help_email": "Email",
  "ss_fan_profile_help_popup_title": "Trợ giúp",
  "ss_fan_profile_info": "Informasi pribadi",
  "ss_fan_upload_button_label": "id_Tải ảnh lên",
  "ss_fan_voucher_label_date": "Kedaluwarsa:",
  "ss_fe_fan_edit_profile_cancel_button": "id_Hủy",
  "ss_fe_fan_edit_profile_confirm_button": "id_Xong",
  "ss_fe_fan_edit_profile_label_confirm": "Konfirmasi",
  "ss_fe_fan_edit_profile_personal_tax_code_had": "id_Đã có",
  "ss_fe_fan_edit_profile_personal_tax_code_had_not": "id_Chưa có",
  "ss_fe_fan_edit_profile_title_calender": "id_Chọn ngày",
  "ss_fe_fan_edit_profile_validate_date_identification": "id_Ngày cấp không hợp lệ",
  "ss_fe_fan_edit_profile_validate_invalid": "Format data salah",
  "ss_fe_fan_edit_profile_validate_max_length": "Maksimal {{num}} karakter",
  "ss_fe_fan_edit_profile_validate_number_0_to_9": "Hanya masukkan angka (0-9)",
  "ss_fe_fan_edit_profile_validate_required": "Kolom tidak boleh kosong",
  "ss_fe_fan_edit_profile_validate_required_file": "id_Trường dữ liệu không được để trống 1 trong 2",
  "ss_fe_fan_profile_address_user": "id_Địa chỉ",
  "ss_fe_fan_profile_address_user_placeholder": "id_Nhập địa chỉ của bạn",
  "ss_fe_fan_profile_country_alias": "Negara",
  "ss_fe_fan_profile_country_chosen": "Pilih negara",
  "ss_fe_fan_profile_country_helper": "Pilih negara sesuai dengan akun pembayaranmu",
  "ss_fe_fan_profile_momo_account": "Akun Momo",
  "ss_fe_fan_profile_momo_account_helper": "Nama di kolom ini harus sesuai dengan nama akun momo dan tidak bisa diubah",
  "ss_fe_fan_profile_momo_account_name": "Isi akun Momo",
  "ss_fe_fan_profile_momo_account_name_placeholder": "Masukkan nama akun Momo",
  "ss_fe_fan_profile_momo_phone_placeholder": "Masukkan akun MoMo",
  "ss_fe_fan_profile_payment_account_name": "Nama Akun",
  "ss_fe_fan_profile_payment_account_number": "No Rekening Bank",
  "ss_fe_fan_profile_payment_account_number_placeholder": "Masukkan Nomor Rekening Bank",
  "ss_fe_fan_profile_payment_alias": "Pembayaran",
  "ss_fe_fan_profile_payment_bank_account": "No Rekening",
  "ss_fe_fan_profile_payment_bank_alias": "Bank Penerima",
  "ss_fe_fan_profile_payment_bank_name_placeholder": "Nama Akun Penerima Bank",
  "ss_fe_fan_profile_payment_branch": "Cabang",
  "ss_fe_fan_profile_payment_branch_new_placeholder": "id_Nhập chi nhánh ngân hàng của bạn",
  "ss_fe_fan_profile_payment_branch_placeholder": "Masukkan nama cabang",
  "ss_fe_fan_profile_payment_date_identification": "id_Ngày phát hành KTP",
  "ss_fe_fan_profile_payment_file_back": "id_Mặt sau",
  "ss_fe_fan_profile_payment_file_front": "id_Mặt trước",
  "ss_fe_fan_profile_payment_file_helper": "id_Đính kèm 2 ảnh KTP của bạn: Mặt trước, mặt sau. Yêu cầu tải lên hình ảnh rõ ràng, chi tiết.",
  "ss_fe_fan_profile_payment_identification": "id_Số KTP",
  "ss_fe_fan_profile_payment_identification_placeholder": "id_Nhập số KTP",
  "ss_fe_fan_profile_payment_image_identification": "id_Ảnh KTP(Passport)",
  "ss_fe_fan_profile_payment_personal_tax": "id_Mã số thuế",
  "ss_fe_fan_profile_payment_personal_tax_placeholder": "id_Nhập mã số thuế cá nhân",
  "ss_fe_fan_profile_tl_alias": "Thailand",
  "ss_fe_fan_profile_vn_alias": "Vietnam",
  "ss_fe_fan_voucher_title": "Kode diskon",
  "ss_for_you": "Kirim ke Anda 🤗",
  "ss_hotline": "Hotline",
  "ss_label_tod_link_success": "Kebenaran Informasi tunggal atau Berani telah dikirim ke email",
  "ss_lable_back_success_donation": "Detail dukungan",
  "ss_lable_back_success_tod": "Rincian Pembayaran",
  "ss_lable_link_success": "Informasi Dukungan telah dikirim ke email",
  "ss_logout": "Keluar",
  "ss_modal_timeout_register_now": "ลงทะเบียนตอนนี้",
  "ss_next_register": "Buat Akun",
  "ss_no": "Tidak",
  "ss_order_code": "Pesanan Kode",
  "ss_order_date": "Pesanan waktu",
  "ss_order_detail": "Detail pesanan",
  "ss_order_fail": "Pesanan gagal",
  "ss_order_history_accepted": "Menunggu",
  "ss_order_history_empty_text": "Anda saat ini tidak memiliki produk apa pun",
  "ss_order_history_empty_text_suggest": "Silakan beli produk untuk mendukung KOL",
  "ss_order_history_new": "Baru",
  "ss_order_history_refund": "Mengembalikan",
  "ss_order_history_replied": "Dibuat",
  "ss_order_history_reply_text": "Membalas",
  "ss_order_message_from_kol": "Umpan balik dari Kol",
  "ss_order_message_from_user": "Pesan dari Anda",
  "ss_order_momo_wallet": "Momo e-Wallet",
  "ss_order_note_lucky_sent_email": "Uang beruntung telah dikirim ke email",
  "ss_order_note_sent_email": "Pesanan telah dikirim ke email",
  "ss_order_pending": "Transaksi sedang dalam proses",
  "ss_order_pending_title": "Transaksi sedang dalam proses",
  "ss_order_success": "Pesanan kesuksesan",
  "ss_order_tod_date": "Waktu pembayaran",
  "ss_order_tod_message_from_kol": "Respons dari pencipta",
  "ss_payment_GBPRIMEPAY_CREDIT_CARD": "Credit Cards",
  "ss_payment_GBPRIMEPAY_QRCASH": "PromptPay",
  "ss_payment_GBPRIMEPAY_RABBIT_LINEPAY_WALLET": "LinePay",
  "ss_payment_GBPRIMEPAY_SHOPEEPAY_WALLET": "ShopeePay Wallet",
  "ss_payment_GBPRIMEPAY_TRUEMONEY_WALLET": "TrueMoney Wallet",
  "ss_payment_GBPRIMEPAY_WECHAT_WALLET": "Wechat Wallet",
  "ss_payment_history": "Sejarah pesanan",
  "ss_payment_history_brand_rating": "id_Brand Ratings",
  "ss_payment_history_digital_product": "Produk digital",
  "ss_payment_history_donation": "Sumbangan",
  "ss_payment_history_gift": "Hadiah",
  "ss_payment_history_tod": "Kebenaran atau tantangan",
  "ss_payment_method": "Cara Pembayaran",
  "ss_payment_vnpay_qr_description": "id_Nhớ dùng mã giảm giá VNPAY bạn nhé!",
  "ss_payment_xendit_dana": "Dompet Dana",
  "ss_payment_xendit_gcash": "GCash Wallet",
  "ss_payment_xendit_grabpay": "Dompet ambil",
  "ss_payment_xendit_ovo": "Dompet ovo",
  "ss_payment_xendit_paymaya": "PayMaya Wallet",
  "ss_payment_xendit_shopeepay": "Shopeepay Indo",
  "ss_payment_xendit_virtual_account": "Akun virtual",
  "ss_payment_xendit_virtual_account_bottom": "Bank Transfer",
  "ss_placeholder_profile_email": "Masukkan email",
  "ss_placeholder_profile_fullname": "Masukkan nama lengkapmu",
  "ss_placeholder_profile_fullphone": "Masukkan Nomor Telepon Anda",
  "ss_placeholder_profile_username": "Masukkan nama pengguna",
  "ss_price_max_discount": "Memperkecil",
  "ss_product_name": "Nama produk",
  "ss_profile": "Mengajukan",
  "ss_profile_account_not_acctive": "Akun tidak diautentikasi",
  "ss_profile_active_account": "Diautentikasi sekarang",
  "ss_profile_btn_edit": "Edit informasi",
  "ss_profile_btn_edit_cancel": "Membatalkan",
  "ss_profile_btn_edit_save": "Menyimpan",
  "ss_profile_change_email_success": "Informasi yang berhasil",
  "ss_profile_email": "Surel",
  "ss_profile_error_email": "Harap masukkan format email yang benar",
  "ss_profile_error_email_required": "Harap masukkan email",
  "ss_profile_error_username_existed": "nama pengguna tersedia",
  "ss_profile_error_username_matches": "Hanya karakter yang diizinkan dari A-Z dan 0-9",
  "ss_profile_error_username_required": "Harap masukkan nama pengguna",
  "ss_profile_fullname": "Nama lengkap",
  "ss_profile_fullname_error_max_length": "Harap masukkan karakter maksimum {{max}}",
  "ss_profile_fullphone": "Nomor telepon",
  "ss_profile_fullphone_error": "Anda memasukkan nomor telepon yang benar",
  "ss_profile_helptext_email": "Jika Anda mengubah email Anda, Anda perlu mengotentikasi akun Anda",
  "ss_profile_helptext_email_actived": "Email telah diverifikasi",
  "ss_profile_username": "nama belakang",
  "ss_profile_username_error_max_length": "Hanya mengizinkan hingga 255 karakter",
  "ss_question_dare_for_you": "Tantangan dari Anda",
  "ss_question_truth_for_you": "Pertanyaan dari Anda",
  "ss_recurring_payment_button_submit": "id_Thanh toán định kỳ",
  "ss_recurring_payment_field_email": "id_Email",
  "ss_recurring_payment_field_full_name": "id_Họ và tên",
  "ss_recurring_payment_field_phone": "id_Số điện thoại",
  "ss_recurring_payment_helper_field_email": "id_Sản phẩm của bạn sẽ được gửi qua email, bạn nhập chính xác nhé.",
  "ss_recurring_payment_info_title": "id_Thông tin khách hàng",
  "ss_recurring_payment_month": "id_tháng",
  "ss_recurring_payment_placeholder_field_email": "id_Your@example.com",
  "ss_recurring_payment_placeholder_field_full_name": "id_Tran Van A",
  "ss_recurring_payment_placeholder_field_phone": "id_09xxxxxxxxxx",
  "ss_referral_button_share": "Referensi kan temanmu sekarang",
  "ss_referral_campaign": "Referensi kan temanmu sekarang",
  "ss_referral_copy_link_error": "Gagal mengcopy link referral",
  "ss_referral_copy_link_success": "Sukses mengcopy link referral",
  "ss_referral_creator_name": "Kreator",
  "ss_referral_intro_step_1": "Copy link referral produk",
  "ss_referral_intro_step_1_title": "Langkah 1:",
  "ss_referral_intro_step_2": "Bagikan ke temanmu",
  "ss_referral_intro_step_2_title": "Langkah 2:",
  "ss_referral_intro_step_3": "Dapatkan bonus ketika temanmu sukses melakukan pembelian",
  "ss_referral_intro_step_3_title": "Langkah 3:",
  "ss_referral_intro_title_page": "Referensikan temanmu dan dapatkan hadiah",
  "ss_referral_reward_recived": "Hadiahmu",
  "ss_referral_text_intro_description": "Hadiah yang kamu terima adalah \"Hati\" di Passio. Hadiah ini dapat ditukarkan untuk hadiah pulsa. Semakin banyak teman yang kamu referensikan semakin banyak bonusnya. Yuk coba ajak temanmu sekarang!",
  "ss_referral_text_title": "Produk yang saat ini kamu referensikan",
  "ss_referral_title_page": "Referensi kan temanmu",
  "ss_register_link_to_login_page": "เข้าสู่ระบบ",
  "ss_register_success": "Pendaftaran akun yang berhasil",
  "ss_retry": "Mencoba kembali",
  "ss_showing": "Menunjukkan",
  "ss_store_btn_checkout": "Membayar",
  "ss_store_can_not_place_order": "Tidak dapat melakukan pemesanan saat ini. Silakan coba lagi nanti",
  "ss_store_checkout_email_notification": "👉 Produk Anda akan dikirim melalui email, masukkan dengan tepat.",
  "ss_store_checkout_email_notification_bg": "Produk Anda akan dikirim melalui email, masukkan dengan tepat.",
  "ss_store_checkout_email_title": "Surel",
  "ss_store_checkout_error_E1": "Tidak dapat melakukan pemesanan saat ini. Silakan coba lagi nanti",
  "ss_store_checkout_error_E2": "Maaf! Kode diskon ini telah kedaluwarsa",
  "ss_store_checkout_error_E3": "Belum menggunakan kode. Silakan coba lagi nanti!",
  "ss_store_checkout_error_E4": "Oppp. Kode diskon telah kedaluwarsa",
  "ss_store_checkout_error_E5": "Kamu telah membeli kelas ini. Silahkan cek history pembelian",
  "ss_store_checkout_error_EC": "The product is not available",
  "ss_store_checkout_error_EC1": "Out of stock",
  "ss_store_checkout_error_ES": "Tidak bisa memesan lagi nanti",
  "ss_store_checkout_phone_placeholder": "09xxxxxx",
  "ss_store_checkout_phone_title": "Nomor telepon",
  "ss_store_checkout_private_message_title": "Atur pesan dalam mode pribadi",
  "ss_store_checkout_user_message_title": "Pesan",
  "ss_store_confirm_leave_order": "Apakah Anda ingin pergi dari sini?",
  "ss_store_copy_successfully": "Salin berhasil",
  "ss_store_copy_to_other_brower": "Harap salin jalur ini dan tempel ke safari untuk melanjutkan",
  "ss_store_copy_url": "Salin jalurnya",
  "ss_store_create_account": "Buat Akun ?",
  "ss_store_customer_information": "Informasi pengguna",
  "ss_store_donation": "Info Donasi",
  "ss_store_donation_payment_title": "Pilih metode pembayaran",
  "ss_store_email_require": "Harap masukkan email",
  "ss_store_free": "Gratis",
  "ss_store_invalid_email": "Anda memasukkan format email yang benar",
  "ss_store_invalid_phone": "Tolong isi nomor telphone yang benar ya!",
  "ss_store_invalid_username": "Hanya karakter yang diizinkan adalah kata-kata biasa dari a-z dan 0-9",
  "ss_store_leave": "Meninggalkan",
  "ss_store_momo_wallet": "Momo e-Wallet",
  "ss_store_order_detail": "Membayar",
  "ss_store_order_item": "Informasi produk",
  "ss_store_password_min_length": "Panjang minimum 6 karakter",
  "ss_store_password_require": "Harap masukkan kata sandi",
  "ss_store_payment_deeplink": "Tautan pembayaran",
  "ss_store_phone_require": "Tolong isi nomor telphone yang benar ya!",
  "ss_store_require_payment": "Mohon pilih salah satu metode pembayaran",
  "ss_store_shopeepay_wallet": "Shopeepay E -Wallet",
  "ss_store_shoutout_item": "Shoutout Informasi Video",
  "ss_store_tod_user_message_max_length": "Konten melebihi 500 karakter.",
  "ss_store_user_message_max_length": "Beberapa informasi melebihi karakter yang diizinkan untuk masuk, periksa lagi",
  "ss_store_user_message_passio_placeholder": "Tolong SMS kami!",
  "ss_store_user_message_placeholder": "Anda mencoba sesuatu dengan pencipta 🤑",
  "ss_store_user_message_tooltip": "Pesannya tidak ditampilkan di depan umum di mana pun, hanya Anda dan pencipta yang bisa dilihat",
  "ss_store_username_max_length": "Hanya mengizinkan hingga 255 karakter",
  "ss_store_username_require": "Harap masukkan nama pengguna",
  "ss_store_virtual_item": "Informasi Hadiah",
  "ss_store_vnpay_atm": "Kartu ATM",
  "ss_store_vnpay_atm_description": "Dukungan Perbankan Internet",
  "ss_store_vnpay_credit_card": "Kartu Kredit / Debit Internasional",
  "ss_store_vnpay_qr": "VNPAY-QR / Internet banking",
  "ss_success_name_kol": "kesuksesan",
  "ss_suggest_register_modal_content_text": "Anda perlu masuk atau mendaftar untuk terus menggunakan layanan kami",
  "ss_support_channel": "Support channel",
  "ss_support_email_info": "info@passio.eco",
  "ss_support_facebook": "Facebook",
  "ss_support_info": "Informasi Dukungan",
  "ss_support_phone_info": "024.77700700",
  "ss_title_tod_dare": "Konten Dare",
  "ss_title_tod_truth": "Konten Truth",
  "ss_tod_checkout_email_notification": "👉 Infomasi tantangan akan dikirim lewat Email, tolong isi format email yang benar ya!",
  "ss_tod_checkout_user_message_title": "Konten tantangan",
  "ss_tod_dare_btn_checkout": "Pembayaran",
  "ss_tod_dare_code": "Kode Dare",
  "ss_tod_dare_name_kol": "Kirim tantangan ke",
  "ss_tod_email_require": "Tolong isi alamat Email ya!",
  "ss_tod_invalid_email": "Tolong isi format email yang benar ya!",
  "ss_tod_invalid_phone": "Tolong isi nomor telphone yang benar ya!",
  "ss_tod_message_require": "Tidak boleh kosong",
  "ss_tod_pending_title": "Pertukaran sedang dalam proses",
  "ss_tod_phone_require": "Tolong isi no handphone kamu ya!",
  "ss_tod_truth_btn_checkout": "Kirim",
  "ss_tod_truth_code": "Kode kebenaran",
  "ss_tod_truth_name_kol": "Kirim pertanyaan ke",
  "ss_tod_user_message_placeholder": "Coba kirim pesan ke Kreator 🤑",
  "ss_total_price": "Total",
  "ss_verify_account_success": "Selamat. Anda telah berhasil memverifikasi akun Anda",
  "ss_video_shoutout_to": "Kirim permintaan ke {{creator_name}}",
  "ss_view_detail": "Lihat detailnya",
  "ss_voucher_has_not_been_used": "Belum menggunakan kode. Silakan coba lagi nanti!",
  "ss_voucher_not_exist": "Kode diskon tidak ada!",
  "ss_voucher_out_of_use": "Oppp. Kode diskon telah kedaluwarsa",
  "ss_watch_content": "Lihat Konten",
  "ss_watch_order_history": "Produk telah dibeli",
  "ss_your_voucher_code": "Kode diskon Anda",
  "sure_cancle_password": "Anda yakin ingin membatalkan perubahan?",
  "system_error": "Sistem bermasalah",
  "title_checkout": "Passio - Pembayaran",
  "username": "Nama belakang",
  "username_placeholder": "Masukkan nama pengguna",
  "video_shoutout": "Video Shoutout"
} 
} 
export default id